import { Card as MuiCard } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

import { getDesignTokens } from '~/client/components/base/core';

export interface GenericCardProps {
  className?: string;
  children: React.ReactNode;
  variant?: 'default' | 'assessment' | 'policy' | 'minimal';
  size?: 'small' | 'medium' | 'large' | 'custom';
  width?: number | string;
  height?: number | string;
  elevation?: number;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

const GenericCardImpl: React.FC<GenericCardProps> = ({
  className,
  children,
  variant = 'default',
  size = 'medium',
  width,
  height,
  elevation,
  onClick,
}) => {
  return (
    <MuiCard
      className={className}
      elevation={elevation}
      onClick={onClick}
      sx={{
        ...(width && { width }),
        ...(height && { height }),
      }}
    >
      <div className="enhanced-card-container">{children}</div>
    </MuiCard>
  );
};

export const GenericCard = muiStyled(GenericCardImpl)(({
  theme,
  variant,
  size,
  width,
  height,
}) => {
  const tokens = getDesignTokens(theme.palette.mode, theme.accentPalette);
  return css`
    &.MuiCard-root {
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      /* Variant-based styling */
      ${variant === 'default' && `background: ${tokens.surface1};`}

      ${variant === 'assessment' &&
      `
          background: ${tokens.surface1};
          border: none;
          border-radius: 4px;
          box-shadow: 0 -3px 6px ${tokens.borderSubtle};
        `}

        ${variant === 'policy' &&
      `
          background: ${tokens.surface1};
          border: none;
          border-radius: 4px;
          box-shadow: 0 -3px 6px ${tokens.borderSubtle};
        `}

        ${variant === 'minimal' &&
      `
          background: ${tokens.surface1};
          box-shadow: none;
          border: 1px solid ${tokens.borderSubtle};
        `}

        /* Size-based dimensions */
        ${size === 'small' &&
      !width &&
      !height &&
      `
          width: 200px;
          height: 180px;
        `}

        ${size === 'medium' &&
      !width &&
      !height &&
      `
          width: 250px;
          height: 220px;
        `}

        ${size === 'large' &&
      !width &&
      !height &&
      `
          width: 300px;
          height: 280px;
        `}
    }

    .enhanced-card-container {
      display: flex;
      flex-direction: column;
      height: 100%;
    }
  `;
});
